/* src/js/sectionBlock-main.js */

jQuery( document ).ready(function( $ ) {


    enquire.register("screen and (max-width:850px)", {

        // OPTIONAL
        // If supplied, triggered when a media query matches.
        match: function () {
            console.log('850px is matched');



            //$('#js-move-cats').remove().clone().insertAfter('#js-move-cats-target');




        },

        unmatch: function () {
            console.log('850px is un-matched');




            //$('#js-star-move').remove().clone().appendTo('.profileBox-big .profileBox__imgWrap');









        },

        // OPTIONAL
        // If supplied, triggered once, when the handler is registered.
        setup: function () {
        },

        // OPTIONAL, defaults to false
        // If set to true, defers execution of the setup function
        // until the first time the media query is matched
        deferSetup: true,

        // OPTIONAL
        // If supplied, triggered when handler is unregistered.
        // Place cleanup code here
        destroy: function () {
        }

    });

});